import { Pipe, PipeTransform } from '@angular/core';
import { StandingsConfig } from './standings-config';
import { RaceStanding } from '../race/race-standing';

@Pipe({
  name: 'standingFilter'
})
export class StandingFilterPipe implements PipeTransform {
  transform(raceStanding: RaceStanding, standingsConfig: StandingsConfig): boolean {
    for (let feature in standingsConfig) {
      if (!(feature in raceStanding.driver.features)
        || (Array.isArray(standingsConfig[feature])
          ? (standingsConfig[feature] as [number | string]).indexOf(raceStanding.driver.features[feature]) < 0
          : raceStanding.driver.features[feature] !== standingsConfig[feature])
      ) {
        return false;
      }
    }
    return true;

    /*return (
        standingsConfig.category === undefined
        || (Array.isArray(standingsConfig.category)
          ? standingsConfig.category.find(category => category == raceStanding.driver.category)
          : raceStanding.driver.features.category === standingsConfig.category)
      )
      && (standingsConfig.group === undefined || raceStanding.driver.group === standingsConfig.group)
      && (standingsConfig.stock === undefined || raceStanding.driver.features.stock === standingsConfig.stock)
      && (standingsConfig.women === undefined || raceStanding.driver.women === standingsConfig.women)
      && (standingsConfig.yt === undefined || raceStanding.driver.yt === standingsConfig.yt)*/
  }
}
